import { FormPayload, PaymentFormSchema } from '@cashier/cashier-model';

export const extractAmountValue = (
  formSchema: PaymentFormSchema,
  formPayload: FormPayload,
): string | null => {
  const amountField = formSchema?.staticData.amount || null;

  if (!amountField) {
    return null;
  }

  const amountValue = formPayload[amountField.name]?.value || null;

  return amountValue === null ? null : (amountValue as string);
};
